import { lang, commonLang, getCurrentSystem } from '@umu/ukit-lang';
/***
 * @file 每日登录
 *
 */

import React from 'react';
import { openWindow } from '@umu/umu-util';
import { getModuleData } from 'common/src/services';
import { If } from 'common/src/components';

import './dailyLogin.scss';
import upImg from '../../images/up.png';

const currentSystem = getCurrentSystem();

interface IProps {
    activeDays: number;
    growthPoints: number;
    showLoginAchievement: boolean;
    onClose: () => void;
}

export default class DailyLogin extends React.Component<IProps, {}> {
    constructor(props: IProps) {
        super(props);
    }

    public onClose = () => {
        this.props.onClose();
    };

    public renderLoginProgress() {
        /* const data = this.props.data;
        const days = data.active_days; */

        const days = this.props.activeDays;
        const dayCountBase = days - (days % 5 || 5);
        const dayCountList = Array(6)
            .join('0')
            .split('')
            .map((_v, i) => dayCountBase + i + 1);

        return (
            <div className="daily-login-progress">
                <div className="progress-list">
                    <div className="progress-list-wrap">
                        {dayCountList.map((day, index) => {
                            const cls = `
                                progress-item
                                ${day <= days ? 'activated' : ''}
                                ${day === days ? 'current' : ''}
                            `;

                            return (
                                <div className={cls} key={index}>
                                    <div className="check"></div>
                                    <div className="count">{day}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    public render() {
        // const data = this.props.data;
        const days = this.props.activeDays;
        const points = this.props.growthPoints;
        const showLoginAchievement = this.props.showLoginAchievement;
        const viewAchievement = () => {
            const siteHost = getModuleData('siteHost');
            openWindow(`m.${siteHost}/profile/achievement`);
            this.onClose();
        };

        return (
            <div className="daily-login-dialog">
                <span className="daily-close" onClick={this.onClose} />
                <div className={`daily-login-header ${currentSystem === 'EN' ? 'com' : ''}`} />
                <div className="daily-login-card">
                    <div className="title">{lang('已连续登录')}</div>
                    <div className="info">
                        <span className="days">{days}</span>
                        {commonLang('天', days)}
                    </div>
                    <div className="desc">{lang('持续登录将获得更高UP值奖励')}</div>
                    <div className="points">
                        <span>{lang('今日获得')}</span>
                        <img alt="up" className="up-img" src={upImg} />
                        <span className="up-num">+{points}</span>
                    </div>
                    <div className="actions clearfix">
                        <If condition={showLoginAchievement}>
                            <button onClick={viewAchievement} className="umu-btn preview">
                                {lang('查看我的成就')}
                            </button>
                        </If>
                        <button onClick={this.onClose} className="btn alias-plain type-primary btn-primary know">
                            {lang('知道了')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
